import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 100%;
`

export const PanelistName = styled.div`
  padding-top: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #363636;
`
export const PanelistEmail = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #757575;
  padding-bottom: 15px;
`

export const JoinURL = styled.div`
  pointer-events: none;
  width: 80%;
`

export const CopyButton = styled.div`
  button {
    background-color: #e7f3fe;
    border-radius: 8px;
    color: #0085ff;
    font-size: 14px;
    font-weight: 700;

    &:hover {
      background-color: #e7f3fe;
      color: #0085ff;
    }
  }
`
